import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import * as styles from './index.vanilla.css'

interface Props {
  children: React.ReactNode
}

export const Timeline = ({ children }: Props) => {
  const validChildren = React.Children.toArray(children).filter((child) => !!child)
  const childrenCount = React.Children.count(validChildren)

  if (childrenCount < 2) {
    return children
  }

  return (
    <Box flexDirection="row" paddingY="s12" paddingLeft="s24" gap="s24">
      <Box width="full" gap="s24">
        {React.Children.map(
          validChildren,
          (child, index) =>
            !!child && (
              <Box key={index} position="relative" className={styles.timelineBox}>
                <Box>{child}</Box>
              </Box>
            )
        )}
      </Box>
    </Box>
  )
}
